module.exports = __webpack_public_path__ + "static/media/add_new.2ece666f.svg";